// extracted by mini-css-extract-plugin
module.exports = {"makeModel":"VrmModal_makeModel__Jdipr","subtitle":"VrmModal_subtitle__2APn7","vrmModal":"VrmModal_vrmModal__PEefA","vrm":"VrmModal_vrm__NOVkX"};